import { c as _c } from "react/compiler-runtime";
import { NEWSLETTERS_API } from 'modules/newsletters/single/api/newsletters-api';
import { NewsletterId } from 'modules/newsletters/single/types/newsletter-interface';
import { NewsletterViewApiType } from 'modules/newsletters/single/types/newsletter-view-interface';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
interface useGetNewsletterViewInterface {
  newsletterId: NewsletterId;
}
export function useGetNewsletterView(t0) {
  const $ = _c(6);
  const {
    newsletterId
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  const t2 = `${NEWSLETTERS_API}/${newsletterId}`;
  let t3;
  if ($[1] !== t2) {
    t3 = [t2, RequestModuleEnum.Tags];
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const {
    data: newsletterData,
    mutate: mutateNewslettersData
  } = useControlledSwr(t3, fetcher, undefined, !!user);
  let t4;
  if ($[3] !== mutateNewslettersData || $[4] !== newsletterData) {
    t4 = {
      newsletterData,
      mutateNewslettersData
    };
    $[3] = mutateNewslettersData;
    $[4] = newsletterData;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}